import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class PressureAttribute extends Sensor {
  public pressureChart: any;
  private pressureSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.pressureChart = null;
    this.pressureSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.pressureSensor, position);
      this.pressureSensor[position].push([timestamp, element.pressure]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredPressure = this.pressureSensor.filter(series => series.length > 0);

    const positionNodePressure = this.pressureSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.pressureChart = this.getConfigChar(
      'pressure',
      this.getChartSeriesNewNode('Sensor', filteredPressure, positionNodePressure),
      this.getRanges('pressure'),
      this.getLimits('pressure')
    );
  }

  public hasPressureSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.pressureSensor.length &&
      this.pressureSensor[index].length > 0
    );
  }

  public getPressureSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.pressureSensor.length) {
      const sensorData = this.pressureSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Presión', value: 'pressure' }
    ];
  }
}
